const hinge = [
  {
    id: 1,
    type: "hingeColor",
    label: "Bronze",
    disabled: false
  },
  {
    id: 2,
    type: "hingeColor",
    label: "Stainless Steel",
    disabled: false
  },
];

const hingePivot = [
  {
    id: 1,
    type: "hingeColor",
    label: "Black",
    disabled: false
  },
  {
    id: 2,
    type: "hingeColor",
    label: "Stainless Steel",
    disabled: false
  },
];

const hingeFritsDropseal = {
    id: 2,
    type: "hingeColor",
    label: "Stainless Steel",
    disabled: false
}

const hingeEmtek = [
  {
    id: 1,
    type: "hingeColor",
    label: "Polished Brass",
    imgId: "Handles/colors/emtek/Polished_Brass",
  },
  {
    id: 2,
    type: "hingeColor",
    label: "Satin Brass",
    imgId: "Handles/colors/emtek/Satin_Brass",
  },
  {
    id: 3,
    type: "hingeColor",
    label: "French Antique",
    imgId: "Handles/colors/emtek/French_Antique",
  },
  {
    id: 5,
    type: "hingeColor",
    label: "Polished Nickel",
    imgId: "Handles/colors/emtek/Polished_Nickel",
  },
  {
    id: 6,
    type: "hingeColor",
    label: "Satin Nickel",
    imgId: "Handles/colors/emtek/Satin_Nickel",
  },
  {
    id: 7,
    type: "hingeColor",
    label: "Pewter",
    imgId: "Handles/colors/emtek/Pewter",
  },
  {
    id: 9,
    type: "hingeColor",
    label: "Polished Chrome",
    imgId: "Handles/colors/emtek/Polished_Chrome",
  },
  {
    id: 4,
    type: "hingeColor",
    label: "Oil Rubbed Bronze",
    imgId: "Handles/colors/emtek/Oil_Rubbed_Bronze",
  },
  {
    id: 8,
    type: "hingeColor",
    label: "Flat Black",
    imgId: "Handles/colors/Matte_Black",
  },
];

const hingeAlumBifold = [
  {
    id: 1,
    type: "hingeColor",
    label: "Black",
    disabled: true
  },
  // {
  //   id: 2,
  //   type: "hingeColor",
  //   label: "Dark Silver",
  // },
];

export { hinge, hingePivot, hingeEmtek, hingeAlumBifold, hingeFritsDropseal };
